<template>
<section class="contactsForm">
  <div class="container">
    <h3>Свяжитесь с нами</h3>
    <div class="row" v-if="formContactState === 0">
      <div class="col-3">
        <div class="input-group">
          <label for="name-1">Имя</label>
          <input type="text" id="name-1" placeholder="Укажите ваше имя">
        </div>
        <div class="input-group">
          <label for="phone-1">Номер телефона</label>
          <input type="text" id="phone-1" placeholder="Укажите ваш номер телефона">
        </div>
        <div class="input-group">
          <label for="area-1">Площадь объекта</label>
          <input type="text" id="area-1" placeholder="м2">
        </div>
      </div>
      <div class="col-7">
        <div class="input-group">
          <label for="comment-1">Комментарий</label>
          <textarea name="comment" id="comment-1" placeholder="Введите текст"></textarea>
        </div>
      </div>
    </div>
    <div class="row button_row" v-if="formContactState === 0">
      <button class="button button_small" @click="sendContactForm()">
        Отправить
      </button>
    </div>
    <div class="row" v-if="formContactState === 1">
      <div class="text">
        Спасибо, скро мы с вами свяжемя
        <button class="button__transparent button_small" @click="resetContactForm ()">Закрыть</button>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'SectionContactsForm',
  components: {
  },
  data () {
    return {
      formContactState: 0
    }
  },
  methods: {
    sendContactForm() {
      this.formContactState = 1
    },
    resetContactForm() {
      this.formContactState = 0
    }
  },
  computed: {
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.contactsForm {
  padding: 45px 0;
  @media (max-width: 997.98px) {
    padding: 20px 0;
  }
  h3 {
    font-weight: 500;
    font-size: 4rem;
    margin-bottom: 20px;
  }
  .row {
    margin: 0 -10px;
    width: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 576.98px) {
      margin: 0;
    }
    .col-3 {
      flex: 0 0 33.333%;
      max-width: 33.333%;
      position: relative;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0 10px;
      @media (max-width: 997.98px) {
        flex: 0 0 100%;
        max-width: 100%;
      }
      @media (max-width: 576.98px) {
        padding: 0;
      }
      .input-group:last-child {
        margin-bottom: 0;
      }
      @media (max-width: 997.98px) {
        .input-group:last-child {
          margin-bottom: 20px;
        }
      }
    }
    .col-7 {
      flex: 0 0 66.667%;
      max-width: 66.667%;
      position: relative;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0 10px;
      @media (max-width: 997.98px) {
        flex: 0 0 100%;
        max-width: 100%;
      }
      @media (max-width: 576.98px) {
        padding: 0;
      }
      .input-group {
        margin-bottom: 0;
        height: 100%;
        textarea {
          resize: none;
          display: flex;
          flex: 1 1 auto;
          border: 1px solid #E0E0E0;
          box-sizing: border-box;
          font-weight: 300;
          font-size: 1.6rem;
          color: #0E0E0E;
          width: 100%;
          padding: 15px 20px;
          height: auto;
          min-height: 150px;
          @media (max-width: 997.98px) {
            resize: vertical;
          }
          &::placeholder {
            font-weight: 300;
            font-size: 1.6rem;
            color: #4F4F4F;
          }
        }
      }
    }
    .text {
      width: 100%;
      height: 100%;
      font-weight: 300;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 2rem;
      button {
        margin-top: 30px;
        font-size: 1.6rem;
      }
    }
  }
  .input-group {
    display: flex;
    flex-direction: column;
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 40px;
    @media (max-width: 997.98px) {
      margin-bottom: 20px;
    }
    input[type="text"] {
      border: 1px solid #E0E0E0;
      box-sizing: border-box;
      font-weight: 300;
      font-size: 1.6rem;
      color: #0E0E0E;
      width: 100%;
      padding: 15px 20px;
      height: auto;
      &::placeholder {
        font-weight: 300;
        font-size: 1.6rem;
        color: #4F4F4F;
      }
    }
    label {
      margin-bottom: 15px;
      font-size: 2rem;
      color: #4F4F4F;
    }
  }
  .button_row {
    display: flex;
    justify-content: center;
    padding: 45px 0;
    margin: 0;
    @media (max-width: 997.98px) {
      padding: 20px 0;
    }
    button {
      padding: 19px 45px;
      @media (max-width: 576.98px) {
        flex: 0 0 100%;
        font-size: 1.6rem;
        font-weight: 300;
      }
    }
  }
}
</style>
